export default __webpack_public_path__ + "static/media/005-hump.b663a44b.png";